<div
  class="tab-edit animate-fade-in"
  *ngIf="(isNew || editing) && canEdit; else tabItem"
  [class.tab-selected]="selected"
  [class.editing]="editing"
  #tabInput
>
  <div class="tab-input-container">
    <div #colorPicker class="tab-color-picker" (click)="togglePicker()">
      <div class="tab-picker-box template-tag-color selected" [ngClass]="style"></div>
      <i [class.visible]="showPicker" class="fa fa-caret-up text-muted tab-color-picker-icon"></i>
      <i [class.visible]="!showPicker" class="fa fa-caret-down text-muted tab-color-picker-icon"></i>
    </div>
    <div
      #colorPickerContainer
      [class.d-flex]="showPicker"
      [ngStyle]="{ 'left.px': colorPickerLeftPosition }"
      class="tab-color-picker-container"
    >
      <div
        *ngFor="let styleItem of styles"
        class="tab-picker-box template-tag-color mr-2 mb-2 ml-2 mt-2"
        [ngClass]="styleItem"
        (click)="selectStyle(styleItem)"
      ></div>
    </div>
    <input
      class="tab-name-input"
      aria-label="Tab name"
      [(ngModel)]="name"
      (keyup.esc)="isNew ? cancelAdd() : cancelEdit()"
      (keyup.enter)="isNew ? addNewTab() : updateTab()"
      #tabNameInput
    />
  </div>
  <i *ngIf="editing" class="fa fa-trash tab-delete-icon sm-text-default-red" (click)="delete()"></i>
</div>
<ng-template #tabItem>
  <a
    (mousedown)="!updating && select()"
    (dblclick)="canEdit && !updating && enableEdit()"
    class="tab"
    [class.template-tag-color]="selected"
    [class.tab-selected]="selected"
  >
    <span class="tab-icons">
      <i
        class="tab-drag-icon cc-icon cc-icon-grip-bar-vertical"
        *ngIf="!updating && canEdit"
        aria-hidden="true"
      ></i>
      <i class="tab-indicator template-tag-color" [ngClass]="style"></i>
    </span>
    {{ name }}
    <span class="tab-icons">
      <i class="tab-loading-update cc-icon cc-icon-spinner-fw" *ngIf="updating"></i>
    </span>
  </a>
</ng-template>
<div class="tab-scroll-into-view" #scrollIntoViewFlag></div>
